import type { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import type { RoleCheck } from '../../types';

interface ProtectedRouteProps {
  children: ReactElement;
  roles?: RoleCheck;
}

function ProtectedRoute({ children, roles }: ProtectedRouteProps) {
  const { user, hasRole } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (roles && !hasRole(roles)) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedRoute;
